export default __webpack_public_path__ + "5169144d6d9c8c9d65da41eadfd5acbb.png";